const refreshHelmStampedRatings = () => {
  const badges = document.querySelectorAll('[data-helm-group-rating]');

  if (!badges.length) return;

  const loadBadges = () => {
    if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
      window.StampedFn.loadBadges();
      return true;
    }

    return false;
  };

  if (loadBadges()) return;

  let attempts = 0;

  const timer = setInterval(() => {
    attempts += 1;

    if (loadBadges() || attempts >= 20) {
      clearInterval(timer);
    }
  }, 250);
};

const initHelmGroupCollection = () => {
  document.querySelectorAll('[data-helm-group-card]').forEach((card) => {
    if (card.dataset.groupInitialized === 'true') return;

    card.dataset.groupInitialized = 'true';

    card.addEventListener('click', (event) => {
      const option = event.target.closest('[data-helm-group-option]');

      if (!option) return;

      const primaryImage = card.querySelector(
        '.helm-group-card__primary img'
      );

      const secondaryWrapper = card.querySelector(
        '.helm-group-card__secondary'
      );

      const secondaryImage = secondaryWrapper?.querySelector('img');

      const imageLink = card.querySelector('[data-helm-group-link]');
      const title = card.querySelector('[data-helm-group-title]');
      const titleLink = card.querySelector('[data-helm-group-title-link]');
      const price = card.querySelector('[data-helm-group-price]');
      const rating = card.querySelector('[data-helm-group-rating]');

      const productTitle = option.dataset.productTitle;
      const productUrl = option.dataset.productUrl;
      const previewUrl = option.dataset.productPreview;
      const imageUrl = option.dataset.productImage;
      const secondaryPreviewUrl =
        option.dataset.productSecondaryPreview;
      const secondaryUrl =
        option.dataset.productSecondaryImage;

      if (title) {
        title.textContent = productTitle;
      }

      if (price) {
        price.textContent = option.dataset.productPrice;
      }

      if (imageLink) {
        imageLink.href = productUrl;
        imageLink.title = productTitle;
      }

      if (titleLink) {
        titleLink.href = productUrl;
        titleLink.title = productTitle;
      }

      card.querySelectorAll('[data-helm-group-option]').forEach((button) => {
        const isActive = button === option;

        button.classList.toggle('is-active', isActive);
        button.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });
      
      if (rating) {
        rating.classList.add('is-loading');

        rating.dataset.id = option.dataset.productId;
        rating.dataset.productSku = option.dataset.productHandle;
        rating.dataset.productType = option.dataset.productType;
        rating.dataset.productTitle = productTitle;

        //rating.innerHTML = '';

        requestAnimationFrame(() => {
          refreshHelmStampedRatings();

          setTimeout(() => {
            rating.classList.remove('is-loading');
          }, 500);
        });
      }

      if (secondaryWrapper && secondaryImage) {
        if (secondaryUrl) {
          secondaryWrapper.hidden = false;

          secondaryImage.removeAttribute('srcset');
          secondaryImage.removeAttribute('sizes');

          if (secondaryPreviewUrl) {
            secondaryImage.src = secondaryPreviewUrl;
          }

          secondaryImage.alt = productTitle;
          secondaryImage.classList.add('is-loading');

          const secondaryRequestId =
            `${Date.now()}-${option.dataset.productId}-secondary`;

          card.dataset.secondaryImageRequest = secondaryRequestId;

          const highResSecondaryImage = new Image();

          highResSecondaryImage.onload = () => {
            if (
              card.dataset.secondaryImageRequest !== secondaryRequestId
            ) {
              return;
            }

            secondaryImage.src = secondaryUrl;

            requestAnimationFrame(() => {
              secondaryImage.classList.remove('is-loading');
            });
          };

          highResSecondaryImage.onerror = () => {
            if (
              card.dataset.secondaryImageRequest !== secondaryRequestId
            ) {
              return;
            }

            secondaryImage.classList.remove('is-loading');
          };

          highResSecondaryImage.src = secondaryUrl;
        } else {
          secondaryWrapper.hidden = true;
          secondaryImage.classList.remove('is-loading');
        }
      }

      if (!primaryImage || !imageUrl) return;

      const requestId =
        `${Date.now()}-${option.dataset.productId}`;

      card.dataset.imageRequest = requestId;

      primaryImage.removeAttribute('srcset');
      primaryImage.removeAttribute('sizes');

      if (previewUrl) {
        primaryImage.src = previewUrl;
      }

      primaryImage.alt = productTitle;
      primaryImage.classList.add('is-loading');

      const highResImage = new Image();

      highResImage.onload = () => {
        if (card.dataset.imageRequest !== requestId) return;

        primaryImage.src = imageUrl;

        requestAnimationFrame(() => {
          primaryImage.classList.remove('is-loading');
        });
      };

      highResImage.onerror = () => {
        if (card.dataset.imageRequest !== requestId) return;

        primaryImage.classList.remove('is-loading');
      };

      highResImage.src = imageUrl;
    });
  });
};

const refreshHelmGroupCollection = () => {
  initHelmGroupCollection();

  setTimeout(() => {
    refreshHelmStampedRatings();
  }, 150);
};

const observeHelmGroupCollection = () => {
  refreshHelmGroupCollection();

  const page = document.querySelector('#MainContent') || document.body;

  let productGrid = document.querySelector('#ProductGridContainer');
  let refreshTimer;

  const observer = new MutationObserver((mutations) => {
    const currentGrid = document.querySelector('#ProductGridContainer');

    if (!currentGrid) return;

    const gridWasReplaced = currentGrid !== productGrid;

    const hasNewGroupCards = mutations.some((mutation) => {
      return Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) return false;

        return (
          node.matches?.('[data-helm-group-card]') ||
          node.querySelector?.('[data-helm-group-card]')
        );
      });
    });

    if (!gridWasReplaced && !hasNewGroupCards) return;

    productGrid = currentGrid;

    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(() => {
      refreshHelmGroupCollection();
    }, 150);
  });

  observer.observe(page, {
    childList: true,
    subtree: true
  });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    observeHelmGroupCollection
  );
} else {
  observeHelmGroupCollection();
}

document.addEventListener('shopify:section:load', () => {
  refreshHelmGroupCollection();
});